import React from 'react'
import { Cascader, Button, Space, Input, Skeleton } from 'antd';
import JobInfo from './JobInfo';
import NoData from '../com/NoData';
import Config from "../../config/Config";
import EventBus from "../../frame/eventBus";
import JobTable from '../com/job/scrollCardTable';
import WidgetAjax from '../../widget/WidgetAjax';
import { checkLogin } from '../com/utils';
import CustomSelect from '../com/select/CustomLabelSelect';
import AddressSelector from '../com/address_selector/index';
let path = Config.getBasePath();
class recommendedJob extends React.Component {
  constructor(props) {
    super(props)
    let location = JSON.parse(sessionStorage.getItem("_user_location_"));
    const search = window.location.search;
    const params = new URLSearchParams(search);
    const word = params.get('word');
    let WKEXP = params.get('WKEXP');
    let { JOBTYPE = undefined } = this.props.location?.state || {};
    if (WKEXP) {
      WKEXP = WKEXP.split(",");
    }

    this.state = {
      location,
      JOBTYPE: [
        { label: "推荐", value: "-1" },
      ],
      typeValue: "-1",
      sortList: [{ label: '智能排序', value: '-1' }, { label: '薪资升序', value: 'asc' }, { label: '薪资降序', value: 'desc' }],
      sortType: '-1',
      filter: {
        DISTRICT: location && location.value ? [location?.value] : ["100000"],
        JOBTYPE: JOBTYPE ? [JOBTYPE] : undefined,
        WKEXP: WKEXP && WKEXP.length > 0 ? WKEXP : undefined,
        word: word || undefined,
        PROPERTY:["11"],
      },
      filterEntity: [
        { options: 'occupationData', value: 'JOBTYPE', label: '职位类型', mode: 'tree' },
        { options: 'eduData', value: 'REQEDU', label: '学历要求', mode: 'multiple' },
        { options: 'salaryData', value: 'SAL', label: '薪资待遇', mode: 'single' },
        { options: 'expData', value: 'REQWE', label: '经验要求', mode: 'single' },
        { options: 'ageData', value: 'REQAGE', label: '年龄要求', mode: 'single' },
      ],
      word: word || undefined,
      jobLoading: false,
      infoLoading: true,
      jobData: [],
      page: 1,
      check_jobId: undefined
    }
  }
  async componentDidMount() {

    this.occupation();
    this.loadDimension('D501');
    this.loadDimension('D500');
    this.loadDimension('D423');
    this.loadDimension('D503');
    this.areaList();
    if (checkLogin) {
      this.getUserInfo();
    }
    EventBus.on('locationChange', this.locationChange);
  }

  componentWillUnmount() {
    EventBus.off('locationChange', this.locationChange);
  }

  locationChange = async (location) => {
    const { filter } = this.state;
    await this.setState({
      location,
      jobData: [],
      page: 1,
      filter: {
        ...filter, DISTRICT: location?.value ? [location?.value] : ["100000"]
      }
    });
    await this.areaList();
  }

  /**
   * 地区
   */
  areaList = () => {
    const { location } = this.state;
    const onAreaList = (res) => {
      if (res.status == 0) {
        this.setState({ areaData: res.results });
      }
    }
    WidgetAjax.ajax({ url: path + '/recruitment/area', params: { hierarchy: "2", parent_code: location?.value || "100000", rank: "4" }, callback: onAreaList });
  }

  //职位类型
  occupation = () => {
    let params = { parent_code: "0" }
    const onOccupation = (result) => {
      if (result.status === 0) {
        const newArray = result.results.filter(obj => obj.name !== '全部' && obj.name !== '常用岗位')
        let arr = this.dataBuild(newArray);
        this.setState({ occupationData: arr });
      }
    }
    WidgetAjax.ajax({ url: path + `/recruitment/job_type`, params, callback: onOccupation }, this.props);
  }


  loadDimension = (code) => {
    WidgetAjax.ajax({ url: path + "/widget/dimension", params: { "dimension": code }, callback: (res) => this.onDimension(res, code) });
  }

  onDimension = (res, code) => {
    if (res.status == 0 && res.results && res.results.length > 0) {
      let arr = res.results[0].values.map((item) => {
        return { label: item.name, value: item.value }
      })
      if (code === 'D501') this.setState({ ageData: arr }); //年龄要求
      else if (code === 'D500') this.setState({ eduData: arr }); //学历要求
      else if (code === 'D423') this.setState({ expData: arr }); //经验要求  
      else if (code === 'D503') this.setState({ salaryData: arr }); //薪资要求
    }
  }

  dataBuild = (data) => {
    let arr = []
    data.map((item) => {
      let datas = {};
      if (item.name != '全部') {
        datas['label'] = item.name;
        datas['value'] = item.value || item.code;
        if (item.child) {
          let child = this.dataBuild(item.child.values);
          datas['children'] = child;
        }
        if (item.children) {
          let child = this.dataBuild(item.children);
          datas['children'] = child;
        }
        arr.push(datas)
      }

    })
    return arr
  }

  /**
   * 职位类型切换
   * @param {*} value 
   */
  onClickTab = async (value) => {
    const { filter } = this.state;
    if (value != "-1") {
      await this.setState({ typeValue: value, filter: { ...filter, JOBTYPE: [value] } });
      this.loadJobData();
    } else {
      await this.setState({ typeValue: value, filter: { ...filter, JOBTYPE: undefined } });
      this.loadJobData();
    }

  }

  /**
   * 智能排序
   * @param {*} value 
   */
  sortChange = async (value) => {
    const { filter } = this.state;
    if (value && value != "-1") {
      this.setState({ filter: { ...filter, sorts: { SALTO: value, SALFROM: value } } });
    } else {
      this.setState({ filter: { ...filter, sorts: undefined } });
    }
    await this.setState({ sortType: value });
    this.loadJobData();
  }

  /**
   * 重置
   */
  reset = async () => {
    await this.setState({ filter: { DISTRICT: ["100000"], PROPERTY:["11"] }, sortType: '-1' });
    this.loadJobData();
  }

  loadJobData = async () => {
    await this.setState({ jobData: [], page: 1 });
  }

  getUserInfo = () => {
    const onUserInfo = (res) => {
      if (res.status == 0) {
        this.setState({resume:res.result});
        if (res.result && res.result?.intention && res.result?.intention?.JOBTYPE && res.result?.intention?.JOBTYPE.length > 0) {
          let arr = [...this.state.JOBTYPE];
          res.result.intention.JOBTYPE.forEach((item) => {
            arr.push({ label: item?.name, value: item?.value });
          });
          this.setState({ JOBTYPE: arr });
        }

      }
    }
    WidgetAjax.ajax({ url: path + '/applicant/resume_info', params: {}, callback: onUserInfo });
  }

  onCheck = async (value) => {

    await this.setState({ check_jobId: value });

    let ele = document.querySelector('.sf-body');

    if( ele )
    {
      ele.scrollTo(0, 0);
    } 

    this.jobInfo(value);
  }

  //获取职位信息
  jobInfo = () => {
    const { check_jobId } = this.state;
    this.setState({ infoLoading: true })
    let params = { id: check_jobId };
    const onJobInfo = (res) => {
      if (res.status === 0) {
        this.setState({ jobInfo: res.result });
      } else {
        this.setState({ jobInfo: {} });
      }
      this.setState({ infoLoading: false })
    };
    WidgetAjax.ajax({ url: path + '/job/info', params, callback: onJobInfo });
  };

  /**
   * 跳转简历
   */
  resume = () => {
    if (checkLogin()) {
      this.props.history.push({ pathname: "/home/resume" });
    } else {
      this.logOut("/home/resume");
    }
  }

  logOut = (URL, state) => {
    this.props.history.push({ pathname: URL ? '/login?redirectURL=' + URL : "/login", state });
    window.location.reload();

  }

  getJob = (value) => {

    if (!value) this.setState({ infoLoading: false })


  }

  toSearch = () => {
    const { word, filter } = this.state;

    this.setState({ filter: { ...filter, word } });
    this.loadJobData();
  }

  handleSelectChange = async (value, name) => {
    const { filter } = this.state;
    if (name === 'SAL'  || name === 'REQAGE'  ) {
      if (value && value.length > 0) {
        this.setState({
          filter: {
            ...filter,
            [name + 'FROM']: value[0].split(",")[0],
            [name + 'TO']: value[0].split(",")[1],
            [name]: value
          }
        });
      } else {
        this.setState({
          filter: {
            ...filter,
            [name + 'FROM']: undefined,
            [name + 'TO']: undefined,
            [name]: []
          }
        });
      }
    } else {
      await this.setState({ filter: { ...filter, [name]: value } });
    }
    this.loadJobData();
  };


  addressChange = async (values) => {
    const { filter } = this.state;
    await this.setState({ filter: { ...filter, DISTRICT: values } });
    this.loadJobData();
  }


  render() {
    const { JOBTYPE, typeValue, areaData, filter, filterEntity, jobInfo, infoLoading, word , resume=undefined } = this.state;

    return <div component-data="recommendedJob">
      <div className='head_filter'>
        <div className="box_1200">
          <div className='filter_tabPane sf-page-tool-between'>
            <div className='tabPane'>
              <div className='tabPane_box'>
                {
                  JOBTYPE && JOBTYPE.length > 0 ?
                    JOBTYPE.map((item, index) => {
                      return <div
                        id={'element' + item.value}
                        style={index == 0 ? { marginRight: '36px' } : {}}
                        className={`tabPane_item ${index > 0 ? 'tabPane_text' : ''} ${item.value === typeValue ? 'tabPane_itemCheck' : ''}`}
                        onClick={() => { this.onClickTab(item.value) }}
                      >{item.label}</div>
                    })
                    : null
                }
              </div>
              <div className='tabPane_add' onClick={() => this.resume()}>
                <img src={require("../../img/resume/add-expect-iocn.svg")} />
              </div>
            </div>

            <div className='search_box'>
              <Space.Compact style={{ width: '100%' }}>
                <Input placeholder="搜索职位" value={word} onChange={(e) => { this.setState({ word: e.target.value }) }} />
                <Button type="primary" onClick={() => { this.toSearch() }} >搜索</Button>
              </Space.Compact>
            </div>
          </div>

          <div className='filter_condition sf-page-tool-between '>
            <div className='tree_list'>

              <div className='sg-GroupFiltering'>
                <AddressSelector
                  options={areaData}
                  onChange={this.addressChange}
                  value={filter?.DISTRICT ? filter?.DISTRICT.filter(s => s !== "100000") : []}
                />
                {
                  filterEntity && filterEntity.map((item) => {

                    if (item?.value === 'JOBTYPE' && typeValue != '-1') {
                      return null
                    } else {
                      return <CustomSelect
                        options={this.state[item?.options]}
                        mode={item?.mode}
                        value={filter[item?.value]}
                        onChange={(value) => this.handleSelectChange(value, item?.value)}
                        className="w-full"
                        customLabel={item?.label}
                      />
                    }

                  })
                }
              </div>
            </div>

            <div className='tree_operate sg-GroupFiltering'>
              {/* <Select placeholder="智能排序" options={sortList} className={filter.sort ? 'has-value tree-Has' : ''} value={sortType} onChange={(value) => { this.sortChange(value) }} suffixIcon={<CaretDownOutlined />} /> */}
              <div className='tree_operate_a' onClick={() => { this.reset() }}>清空筛选条件</div>
            </div>

            <div>
            </div>
          </div>
        </div>
      </div>
      <div className='page box_1200'>

        <div className='recommended_box'>

          <div className='left_job' >
            <JobTable onCheck={this.onCheck} params={filter} onGetJobListCallback={this.getJob} />
          </div>

          <div className='right_job'>
            <div className='info_box'>
              {infoLoading ?
                <div className='job_info_box' style={{ padding: '20px' }}><Skeleton active /></div> :

                jobInfo && jobInfo?.id ?
                  <JobInfo
                    job={jobInfo}
                    onChage={this.jobInfo}
                    resume={resume}
                    history={this.props.history} /> :
                  <div className='job_info_box' style={{ padding: '20px' }}>
                    <NoData width={"230px"} height={"230px"} />
                  </div>
              }
            </div>
          </div>

        </div>
      </div>
    </div>
  }
}

export default recommendedJob;